<template>
  <div>
    <title-bar-back :title="'个人中心'" @back="back">
      <div class="title_right"></div>
    </title-bar-back>
    <div class="top_per bottom_line clearfix" @click="goMessage">
      <img
        :src="getUserInfo.avatarUrl || avatarImg"
        alt=""
        class="per_photo left"
      />
      <div class="per_name left font18 font_weight400 colo0">
        {{ getUserInfo.username }}
      </div>
      <img
        src="@/assets/common/icon_back_b87_24@2x.png"
        alt=""
        class="right_go right"
      />
      <div class="per_det right font12 font_weight400">个人信息</div>
    </div>
    <!-- 实名认证 -->
    <div class="item_item bottom_line clearfix" @click="goCertificationList">
      <div class="left font14 font_weight400 colo0 ">实名认证</div>
      <img
        src="@/assets/common/icon_back_b87_24@2x.png"
        alt=""
        class="right_go right"
      />
      <!-- <div class="right right_det font14 font_weight400">宇超</div> -->
    </div>
    <!-- 收货地址 -->
    <div class="item_item bottom_line clearfix" @click="showAddress">
      <div class="left font14 font_weight400 colo0 ">收货地址</div>
      <img
        src="@/assets/common/icon_back_b87_24@2x.png"
        alt=""
        class="right_go right"
      />
      <!-- <div class="right right_det font14 font_weight400">浙江杭州</div> -->
    </div>
    <!-- 修改密码 -->
    <div class="item_item bottom_line clearfix" @click="goPass">
      <div class="left font14 font_weight400 colo0 ">修改密码</div>
      <img
        src="@/assets/common/icon_back_b87_24@2x.png"
        alt=""
        class="right_go right"
      />
      <!-- <div class="right right_det font14 font_weight400">****</div> -->
    </div>
    <!-- 修改手机号 -->
    <div class="item_item bottom_line clearfix" @click="modifyPhone">
      <div class="left font14 font_weight400 colo0 ">修改手机号</div>
      <img
        src="@/assets/common/icon_back_b87_24@2x.png"
        alt=""
        class="right_go right"
      />
      <div class="right right_det font14 font_weight400">
        {{ getUserInfo.phone }}
      </div>
    </div>
    <!-- 注销账户 暂无 -->
    <!-- <div class="item_item clearfix" @click="modifyPhone">
      <div class="left font14 font_weight400 colo0 ">注销账户</div>
      <img
        src="@/assets/common/icon_back_b87_24@2x.png"
        alt=""
        class="right_go right"
      />
    </div> -->
    <!-- 绑定微信 -->
    <div class="item_item item_mr clearfix" @click="wechatBinding">
      <img src="@/assets/common/wechart@2x.png" alt="" class="right_go left" />
      <div class="left item_mr_r font14 font_weight400 colo0 ">微信</div>
      <img
        src="@/assets/common/icon_back_b87_24@2x.png"
        alt=""
        class="right_go right"
      />
      <div class="right right_chart font14 font_weight400">
        {{
          getUserInfo.userWechat && getUserInfo.userWechat !== null
            ? "已绑定"
            : "未绑定"
        }}
      </div>
    </div>
    <!-- 退出登录 -->
    <div class="log_out font14 font_weight400" @click="logout">退出登录</div>
  </div>
</template>
<script>
import { removeToken } from "@/utils/authority";
import wechat from "@/utils/wechat";
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
export default {
  name: "PersonalCenter",
  components: {
    TitleBarBack
  },
  data() {
    return {
      avatarImg: require("@/assets/mine/per_photo@2x.png")
    };
  },
  computed: {
    getUserInfo() {
      return this.$store.getters.getUserInfo;
    }
  },
  created() {
    if (!this.getUserInfo.username) {
      this.getData();
    }
  },
  methods: {
    back() {
      this.$router.back();
    },
    getData() {
      // getUserInfo
      this.$store
        .dispatch("mine/getUserInfo")
        .then(() => {})
        .catch(() => {});
    },
    goMessage() {
      this.$router.push("/mine/personalmessage");
    },
    //实名认证
    goCertificationList() {
      this.$router.push({
        path: "/mine/certificationlist",
        query: {
          id: this.getUserInfo.id
        }
      });
    },
    //修改手机号
    modifyPhone() {
      this.$router.push({
        path: "/mine/securitycheck",
        query: {
          where: "modifyPhone"
        }
      });
    },
    //修改手机号
    goPass() {
      this.$router.push("/mine/modifypassword");
    },
    //修改地址
    showAddress() {
      this.$router.push("/mine/addresslist");
    },
    // 绑定微信
    wechatBinding() {
      wechat();
      // wechatBinding
      const params = { clientCode: this.clientCode };
      this.$store
        .dispatch("mine/wechatBinding", { params })
        .then(() => {
          this.getData();
        })
        .catch(() => {});
    },
    // 退出登录
    logout() {
      this.$dialog
        .confirm({
          // title: "暂停配送",
          message: "您确定要退出登录吗？",
          confirmButtonText: "确定",
          confirmButtonColor: "#DD9132"
        })
        .then(() => {
          //  调用退出登录（暂无接口，只清空token信息）
          this.$toast("退出登录");
          removeToken();
          this.$router.push("/home");
        })
        .catch(() => {
          // console.log(123)
        });
    }
  }
};
</script>
<style lang="less" scoped>
.title_right {
  width: 36px;
}
.top_per {
  background: #fff;
  padding: 14px 12px;
  .per_photo {
    width: 58px;
    height: 58px;
    border-radius: 50%;
    display: block;
  }
  .per_name {
    margin-left: 12px;
    line-height: 58px;
  }
  .per_det {
    line-height: 58px;
    color: rgba(0, 0, 0, 0.55);
  }
  .right_go {
    margin-top: 17px;
    width: 24px;
  }
}
.bottom_line {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.item_mr {
  margin-top: 12px;
}
.item_mr_r {
  margin-left: 12px;
}
.item_item {
  background: #fff;
  padding: 12px;
  line-height: 24px;
  .right_det {
    color: rgba(0, 0, 0, 0.55);
  }
  .right_go {
    // margin-top: 17px;
    width: 24px;
  }
  .right_chart {
    color: #bf9264;
  }
}
.log_out {
  line-height: 48px;
  background: #fff;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  color: #ff0000;
}
</style>
